import { render, staticRenderFns } from "./Salesquotationslist.vue?vue&type=template&id=1ab6e41c&"
import script from "./Salesquotationslist.vue?vue&type=script&lang=js&"
export * from "./Salesquotationslist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports